export const styles = {
    container: {
        height: '100%',
        maxHeight: 'calc(100vh - 184px)',
    },
    textFieldInput: {
        '& .MuiInputBase-inputMultiline': {
            maxHeight: '420px',
            overflowY: 'auto !important',
        },
    },
};
